import {
  ApartmentOutlined,
  OrderedListOutlined,
  SettingOutlined,
  ShopOutlined,
} from '@ant-design/icons'
import { Segmented, Space, Typography } from 'antd'
import React, { useState } from 'react'

import ManualPriorityConfig from '@/components/StorePriority/ManualPriorityConfig/ManualPriorityConfig'
import BrandsPrioritySort from '@/pages/System/PriorityConfigPage/BrandsPrioritySort/BrandsPrioritySort'
import ExcelDnDPage from '@/pages/System/PriorityConfigPage/ExcelDnDPage/ExcelDnDPage'
import SystemStorePrioritySort from '@/pages/System/PriorityConfigPage/SystemStorePrioritySort/SystemStorePrioritySort'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { hasRoleFromGroup } from '@/utils/auth/roleGroups'

import cn from './PriorityConfigPage.module.scss'

const { Title, Text } = Typography

const PriorityConfigPage: React.FC = () => {
  const [activeTool, setActiveTool] = useState<string | number>('excel')
  const { selectedOrganisation } = useUserInfoStore()
  const isOrgSelected = Object.keys(selectedOrganisation).length > 0
  const canEditStorePriorities = useUserInfoStore((state) =>
    hasRoleFromGroup(state.tokenRoles, 'SENIOR_MANAGERS')
  )

  const themeClass = isOrgSelected ? cn.blueTheme : cn.orangeTheme

  return (
    <div className={`${cn.container} ${themeClass}`}>
      <div className={cn.header}>
        <Space direction="vertical" size={0}>
          <Title level={2} className={cn.pageTitle}>
            <SettingOutlined /> Инженерное меню: Приоритеты
          </Title>
          <Text type="secondary">
            Настройка порядка отображения категорий, брендов, характеристик и
            складов
          </Text>
        </Space>
      </div>

      <div className={cn.selectorWrapper}>
        <Segmented
          block
          size="large"
          value={activeTool}
          onChange={(value) => setActiveTool(value)}
          options={[
            {
              label: 'Категории',
              value: 'excel',
              icon: <ApartmentOutlined />,
            },
            {
              label: 'Бренды',
              value: 'brands',
              icon: <ShopOutlined />,
            },
            {
              label: 'Характеристики',
              value: 'manual',
              icon: <OrderedListOutlined />,
            },
            ...(canEditStorePriorities
              ? [
                  {
                    label: 'Склады',
                    value: 'stores',
                    icon: <ShopOutlined />,
                  },
                ]
              : []),
          ]}
          className={cn.customSegmented}
        />
      </div>

      <div className={cn.contentArea}>
        {activeTool === 'excel' && <ExcelDnDPage />}
        {activeTool === 'brands' && <BrandsPrioritySort />}
        {activeTool === 'manual' && <ManualPriorityConfig />}
        {activeTool === 'stores' && canEditStorePriorities && (
          <SystemStorePrioritySort />
        )}
      </div>
    </div>
  )
}

export default PriorityConfigPage
